import { RxCustomerAPI, RxKongCustomerAPI, RxFileAPI } from '@drifthq/dapper'
import {getAccessToken} from '@drifthq/web-auth'

export const api = {
  createProfile(userId) {
    return RxCustomerAPI
      .post(`/users/${userId}/profile`, {}, { headers: { Authorization: `bearer ${getAccessToken()}` }})
      .checkStatus()
  },
  updateProfile(userId, operations) {
    return RxCustomerAPI
      .patch(`/users/${userId}/profile`, operations)
      .checkStatus()
      .retryWithBackoff()
  },
  fetchProfile(userId) {
    return RxCustomerAPI
      .get(`/users/${userId}/profile`)
      .checkStatus()
      .retryWithBackoff()
  },
  checkUniqueHandle(handle) {
    return RxKongCustomerAPI.head('/users/handle_check', { handle })
  },
  upload(file) {
    const data = new FormData()
    data.append('file', file)
    return RxFileAPI
      .post('/upload', data, { raw: true, headers: {} })
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
    },
}



// WEBPACK FOOTER //
// ./src/modules/profile/api.js